import React from 'react'
import { Flex, FlexProps, Grid, GridProps, Link, Text } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/system'
import { ArrowRight } from '@emotion-icons/heroicons-outline/ArrowRight'
import { Tag } from 'entities/tag'
import { routes } from 'routes'
import {
    JobCardSmall,
    JobCardSmallData,
} from 'containers/blogs/components/job/JobCardSmall'

const ArrowRightIcon = chakra(ArrowRight)

type RelatedJobsProps = {
    jobs?: JobCardSmallData[]
    isFetching: boolean
    tags: Pick<Tag, 'slug' | 'weight'>[]
} & FlexProps &
    Pick<GridProps, 'gridTemplateColumns'>

export const RelatedJobs = ({ jobs, isFetching, tags, ...props }: RelatedJobsProps) => {
    const { gridTemplateColumns, ...flexProps } = props
    const bestTag = tags[0]

    if (!isFetching && (!jobs || (Array.isArray(jobs) && jobs.length === 0))) {
        return null
    }

    return (
        <Flex
            direction="column"
            gridGap="16px"
            data-test="recommended-jobs"
            {...flexProps}
        >
            <Flex justifyContent="space-between">
                <Text variant="functionalButtonsLarge" letterSpacing="-0.01em">
                    Related jobs
                </Text>
                {bestTag && (
                    <Link
                        href={routes.jobsPresetSearch({ tech: { slug: bestTag.slug } })}
                        variant="functionalSemiBold"
                        color="secondary.text"
                        display="flex"
                        alignItems="center"
                        gridGap="8px"
                    >
                        See all
                        <ArrowRightIcon boxSize="19px" strokeWidth={1.5} />
                    </Link>
                )}
            </Flex>
            <Grid
                gridTemplateColumns={gridTemplateColumns}
                gridColumnGap="20px"
                gridRowGap="16px"
            >
                {[0, 1, 2, 3].map(idx => {
                    const job = jobs && jobs[idx]
                    if (!isFetching && !job) {
                        return null
                    }
                    return <JobCardSmall job={job} key={job?.id || idx} />
                })}
            </Grid>
        </Flex>
    )
}
